"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BetOKTrendUtils";

export default function BetOKThreeColSection({ title, items, width = "kbv-v24-odt-item--50" }) {
  return (
    <div className={`kbv-v24-odt-item ${width}`}>
      <div className="kbv-v24-odt-title">
        <span>{title}</span>
      </div>
      <div className="kbv-v24-odt-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="kbv-v24-odt-label">{item.label}</div>
            <div className={`kbv-v24-odt-odds ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
